import styled from "styled-components";

export const Container = styled.div`
  .uploadContainer {
    margin-top: 24px;
  }

  .fileUploadSection {
    margin-top: 24px;
  }

  .uploadArea {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    border: 2px dashed ${({ theme }) => theme.colors.gray};
    border-radius: 4px;
    padding: 24px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary};
      background-color: rgba(0, 0, 0, 0.02);
    }

    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .selectedFileInfo {
    text-align: center;
  }
`;
